import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import React from "react";
import AssetAlertSummary from "./dashboardWidgets/AssetAlertSummary";
import AssetTypesChart from "./dashboardWidgets/AssetTypesChart";
import ProtocolsChart from "./dashboardWidgets/ProtocolsChart";
import ActiveConnectionsChart from "./dashboardWidgets/ActiveConnectionsChart";
import DeviceManagement from "./dashboardWidgets/DeviceManagement";
import NetworkDiagram from "./dashboardWidgets/NetworkDiagram";

export default function DashboardPage() {
	useEffect(() => {
		// getDashboardAnalytics();
	}, []);

	return (
		<>
			<Helmet>
				<title>Dashboard | Sec1 Software Pvt. Ltd.</title>
			</Helmet>

			<div id="kt_app_toolbar" className="app-toolbar pt-12 rounded-0">
				<div
					id="kt_app_toolbar_container"
					className="app-container container-fluid d-flex align-items-stretch"
				>
					<div className="app-toolbar-wrapper d-flex flex-stack flex-wrap gap-4 w-100">
						<div className="page-title d-flex flex-column gap-1 me-3 mb-2">
							<h1 className="page-heading d-flex flex-column justify-content-center text-dark fw-bolder fs-1 lh-0">
								Dashboard
							</h1>
						</div>
					</div>
				</div>
			</div>

			<div id="kt_app_content" className="app-content flex-column-fluid">
				<div
					id="kt_app_content_container"
					className="app-container container-fluid"
				>
					<div className="mb-3">
						<div className="row g-2">
							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i class="ki-duotone ki-devices fs-2hx text-primary">
												<span class="path1"></span>
												<span class="path2"></span>
												<span class="path3"></span>
												<span class="path4"></span>
												<span class="path5"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												00
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													Field device
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i class="ki-duotone ki-setting-2 fs-2hx text-success">
												<span class="path1"></span>
												<span class="path2"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												14
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													Controller
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i class="ki-duotone ki-monitor-mobile fs-2hx text-info">
												<span class="path1"></span>
												<span class="path2"></span>
												<span class="path3"></span>
												<span class="path4"></span>
												<span class="path5"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												05
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													SCADA, HMI
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i class="ki-duotone ki-chart-line-star fs-2hx text-warning">
												<span class="path1"></span>
												<span class="path2"></span>
												<span class="path3"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												00
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													EWS, Historian
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i class="ki-duotone ki-laptop fs-2hx text-danger">
												<span class="path1"></span>
												<span class="path2"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												01
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													Computer
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i
												class="ki-duotone ki-router fs-2hx"
												style={{ color: "#7239ea" }}
											>
												<span class="path1"></span>
												<span class="path2"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												01
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													Network device
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col">
								<div class="card h-lg-100">
									<div class="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
										<div class="m-0">
											<i
												class="ki-duotone ki-abstract-26 fs-2hx"
												style={{ color: "#50cd89" }}
											>
												<span class="path1"></span>
												<span class="path2"></span>
											</i>
										</div>
										<div class="d-flex flex-column my-3 mb-0">
											<span class="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
												40
											</span>
											<div class="m-0">
												<span class="fw-semibold fs-6 text-gray-500">
													Others
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div>
						<div className="">
							<div className="">
								<div className="">
									<div className="">
										<div className="row g-2">
											<AssetAlertSummary />
											<AssetTypesChart />
											<ProtocolsChart />
											<ActiveConnectionsChart />
											<DeviceManagement />
											<NetworkDiagram />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
